import Vue from 'vue'
import configs from '@/config'
import DocumentSystemApi from '@/api/documentSystem'

const { publicDocumentSystemApiUrl } = configs

export const hasBrandImportApi = Boolean(publicDocumentSystemApiUrl)

let resource = null

export const actions = {
  extractBrand: {
    method: 'POST',
    url: `${publicDocumentSystemApiUrl}/api/docsys/ahaslides/api/content/extract-brand`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const extractBrandFromDeck = async (file) => {
  const formData = new FormData()
  formData.append('file', file)
  const uploaded = await DocumentSystemApi.uploadFile(formData)
  const response = await resource.extractBrand({}, { file_hash_id: uploaded.hash_id })
  return response.body
}

const errorCodeOf = (error) => {
  const body = error && (error.body || error.data)
  const detail = body && body.detail
  return (detail && detail.code) || null
}

export default {
  initResource,
  extractBrandFromDeck,
  errorCodeOf,
}
